import { render, staticRenderFns } from "./TeflVirtualVideo.vue?vue&type=template&id=1bd108dc&comments=true&"
import script from "./TeflVirtualVideo.vue?vue&type=script&lang=js&"
export * from "./TeflVirtualVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports